<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <search-box :company-id="companyId" :token="token" :radius-id="radiusId"/>
                </div>
            </div>
            <physician-profile-presenter
                v-if="singleResultProviderEntityId !== null"
                :company-id="companyId"
                :token="token"
                :provider-entity-id="singleResultProviderEntityId"
            ></physician-profile-presenter>
            <search-presenter v-else :company-id="companyId" :token="token"></search-presenter>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SearchBox from "./SearchBox.vue";
    import SearchPresenter from "./SearchPresenter.vue";
    import PhysicianProfilePresenter from "./PhysicianProfilePresenter.vue";

    export default {
        name: "PhysicianSearch",
        props: {
            companyId: {type: [Number], required: true}, radiusId: {type: [Number], required: true},
            token: {type: [String], required: true}
        },
        components: {PhysicianProfilePresenter, SearchPresenter, SearchBox},
        computed: {
            ...mapGetters(['searchResults']),
            singleResultProviderEntityId() {
                if (!Array.isArray(this.searchResults) || this.searchResults.length !== 1) {
                    return null;
                }
                const providerEntityId = this.searchResults[0].providerEntityId;
                return typeof providerEntityId === 'undefined' || providerEntityId === null
                    ? null
                    : Number(providerEntityId);
            }
        }
    }
</script>

<style scoped>

</style>